import { render, staticRenderFns } from "./NoAuth.vue?vue&type=template&id=dcc369ca&scoped=true"
var script = {}
import style0 from "./NoAuth.vue?vue&type=style&index=0&id=dcc369ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc369ca",
  null
  
)

export default component.exports